import React from 'react';
import { Users, Building2, Calendar, MessageSquare, TrendingUp, Activity } from 'lucide-react';
import { tenants } from '../../data/mockData';
interface AdminDashboardProps {
  onNavigate: (page: string, id?: string) => void;
}
export function AdminDashboard({
  onNavigate
}: AdminDashboardProps) {
  const stats = [{
    label: 'Total Tenants',
    value: '6',
    icon: Building2,
    color: 'text-blue-600',
    bg: 'bg-blue-100'
  }, {
    label: 'Total Users',
    value: '1,358',
    icon: Users,
    color: 'text-emerald-600',
    bg: 'bg-emerald-100'
  }, {
    label: 'Active Events',
    value: '89',
    icon: Calendar,
    color: 'text-purple-600',
    bg: 'bg-purple-100'
  }, {
    label: 'Total Posts',
    value: '4,210',
    icon: MessageSquare,
    color: 'text-orange-600',
    bg: 'bg-orange-100'
  }];
  return <div className="space-y-8" data-id="element-79">
      {/* Stats Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-80">
        {stats.map((stat, i) => <div key={i} className="bg-white rounded-xl p-6 border border-slate-200 shadow-sm flex items-center gap-4" data-id="element-81">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${stat.bg} ${stat.color}`} data-id="element-82">
              <stat.icon size={24} data-id="element-83" />
            </div>
            <div data-id="element-84">
              <p className="text-sm font-medium text-slate-500" data-id="element-85">{stat.label}</p>
              <p className="text-2xl font-bold text-slate-900" data-id="element-86">{stat.value}</p>
            </div>
          </div>)}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-87">
        {/* Tenants Overview */}
        <div className="lg:col-span-2 space-y-6" data-id="element-88">
          <div className="flex items-center justify-between" data-id="element-89">
            <h2 className="text-lg font-bold text-slate-800" data-id="element-90">Aktive Tenants</h2>
            <button onClick={() => onNavigate('tenants')} className="text-sm font-medium text-emerald-600 hover:text-emerald-700" data-id="element-91">
              Alle anzeigen &rarr;
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-92">
            {tenants.map(tenant => <div key={tenant.id} onClick={() => onNavigate('tenant-detail', tenant.id)} className="bg-white rounded-xl p-5 border border-slate-200 shadow-sm hover:shadow-md transition-shadow cursor-pointer group" data-id="element-93">
                <div className="flex items-start justify-between mb-4" data-id="element-94">
                  <div className="flex items-center gap-3" data-id="element-95">
                    <div className="w-10 h-10 rounded-full flex items-center justify-center text-xl shadow-sm" style={{
                  backgroundColor: tenant.primaryColor
                }} data-id="element-96">
                      {tenant.logo}
                    </div>
                    <div data-id="element-97">
                      <h3 className="font-bold text-slate-900 group-hover:text-emerald-600 transition-colors" data-id="element-98">
                        {tenant.name}
                      </h3>
                      <p className="text-xs text-slate-500" data-id="element-99">{tenant.league}</p>
                    </div>
                  </div>
                  <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700" data-id="element-100">
                    Active
                  </span>
                </div>

                <div className="grid grid-cols-3 gap-2 pt-4 border-t border-slate-100" data-id="element-101">
                  <div className="text-center" data-id="element-102">
                    <p className="text-lg font-bold text-slate-800" data-id="element-103">
                      {tenant.memberCount}
                    </p>
                    <p className="text-xs text-slate-500" data-id="element-104">Members</p>
                  </div>
                  <div className="text-center border-l border-r border-slate-100" data-id="element-105">
                    <p className="text-lg font-bold text-slate-800" data-id="element-106">
                      {tenant.companyCount}
                    </p>
                    <p className="text-xs text-slate-500" data-id="element-107">Companies</p>
                  </div>
                  <div className="text-center" data-id="element-108">
                    <p className="text-lg font-bold text-slate-800" data-id="element-109">
                      {tenant.eventCount}
                    </p>
                    <p className="text-xs text-slate-500" data-id="element-110">Events</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>

        {/* System Activity */}
        <div className="space-y-6" data-id="element-111">
          <h2 className="text-lg font-bold text-slate-800" data-id="element-112">System Aktivität</h2>
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-113">
            <div className="space-y-6" data-id="element-114">
              {[{
              title: 'Neuer Tenant angelegt',
              desc: 'SC Freiburg wurde erfolgreich registriert.',
              time: 'Vor 2 Stunden',
              icon: Building2,
              color: 'text-blue-500'
            }, {
              title: 'Plattform Update',
              desc: 'Version 2.4.1 wurde erfolgreich deployed.',
              time: 'Gestern',
              icon: Activity,
              color: 'text-emerald-500'
            }, {
              title: 'Nutzer-Meilenstein',
              desc: 'FC Bayern hat 300 aktive Mitglieder erreicht.',
              time: 'Vor 2 Tagen',
              icon: TrendingUp,
              color: 'text-purple-500'
            }, {
              title: 'Event Peak',
              desc: 'Hohe Auslastung durch 3 parallele Heimspiele.',
              time: 'Vor 3 Tagen',
              icon: Calendar,
              color: 'text-orange-500'
            }].map((log, i) => <div key={i} className="flex gap-4" data-id="element-115">
                  <div className={`mt-1 ${log.color}`} data-id="element-116">
                    <log.icon size={18} data-id="element-117" />
                  </div>
                  <div data-id="element-118">
                    <p className="text-sm font-bold text-slate-800" data-id="element-119">
                      {log.title}
                    </p>
                    <p className="text-sm text-slate-600 mt-0.5" data-id="element-120">{log.desc}</p>
                    <p className="text-xs text-slate-400 mt-1" data-id="element-121">{log.time}</p>
                  </div>
                </div>)}
            </div>
            <button className="w-full mt-6 py-2 text-sm font-medium text-slate-600 bg-slate-50 rounded-lg hover:bg-slate-100 transition-colors" data-id="element-122">
              Alle Logs anzeigen
            </button>
          </div>
        </div>
      </div>
    </div>;
}